// LOGIN
export const SUCCESS_LOGIN_ACTION = 'SUCCESS_LOGIN_ACTION';
export const FAIL_LOGIN_ACTION = 'FAIL_LOGIN_ACTION';
export const SUCCESS_LOGOUT_ACTION = 'SUCCESS_LOGOUT_ACTION';
export const FAIL_LOGOUT_ACTION = 'FAIL_LOGOUT_ACTION';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
// SIDEBAR
export const SUCCESS_FETCH_SIDEBAR = 'SUCCESS_FETCH_SIDEBAR';
export const FAIL_FETCH_SIDEBAR = 'FAIL_FETCH_SIDEBAR';
export const SUCCESS_FETCH_ACCESS = 'SUCCESS_FETCH_ACCESS';
export const FAIL_FETCH_ACCESS = 'FAIL_FETCH_ACCESS';
// USERS
export const SUCCESS_FETCH_USERS = 'SUCCESS_FETCH_USERS';
export const FAIL_FETCH_USERS = 'FAIL_FETCH_USERS';
export const SUCCESS_SAVE_USERS = 'SUCCESS_SAVE_USERS';
export const FAIL_SAVE_USERS = 'FAIL_SAVE_USERS';
export const SUCCESS_SHOW_USERS = 'SUCCESS_SHOW_USERS';
export const FAIL_SHOW_USERS = 'FAIL_SHOW_USERS';
export const SUCCESS_UPDATE_USERS = 'SUCCESS_UPDATE_USERS';
export const FAIL_UPDATE_USERS = 'FAIL_UPDATE_USERS';
export const SUCCESS_DELETE_USERS = 'SUCCESS_DELETE_USERS';
export const FAIL_DELETE_USERS = 'FAIL_DELETE_USERS';
export const FAIL_SAVE_USERS_ROLE = 'FAIL_SAVE_USERS_ROLE';
export const SUCCESS_SAVE_USERS_ROLE = 'SUCCESS_SAVE_USERS_ROLE';
// CHANGE PASSWORD
export const SUCCESS_CHANGE_PASSWORD = 'SUCCESS_CHANGE_PASSWORD';
export const FAIL_CHANGE_PASSWORD = 'FAIL_CHANGE_PASSWORD';
// CHANGE PASSWORD BY ADMIN
export const SUCCESS_CHANGE_PASSWORD_BY_ADMIN = 'SUCCESS_CHANGE_PASSWORD_BY_ADMIN';
export const FAIL_CHANGE_PASSWORD_BY_ADMIN = 'FAIL_CHANGE_PASSWORD_BY_ADMIN';
// ROLE
export const SUCCESS_FETCH_ROLE = 'SUCCESS_FETCH_ROLE';
export const FAIL_FETCH_ROLE = 'FAIL_FETCH_ROLE';
export const SUCCESS_SAVE_ROLE = 'SUCCESS_SAVE_ROLE';
export const FAIL_SAVE_ROLE = 'FAIL_SAVE_ROLE';
export const SUCCESS_SHOW_ROLE = 'SUCCESS_SHOW_ROLE';
export const FAIL_SHOW_ROLE = 'FAIL_SHOW_ROLE';
export const SUCCESS_UPDATE_ROLE = 'SUCCESS_UPDATE_ROLE';
export const FAIL_UPDATE_ROLE = 'FAIL_UPDATE_ROLE';
export const SUCCESS_DELETE_ROLE = 'SUCCESS_DELETE_ROLE';
export const FAIL_DELETE_ROLE = 'FAIL_DELETE_ROLE';
export const SUCCESS_FETCH_ROLE_PERMISSIONS = 'SUCCESS_FETCH_ROLE_PERMISSIONS';
export const FAIL_FETCH_ROLE_PERMISSIONS = 'FAIL_FETCH_ROLE_PERMISSIONS';
export const FAIL_SAVE_ROLE_PERMISSIONS = 'FAIL_SAVE_ROLE_PERMISSIONS';
export const SUCCESS_SAVE_ROLE_PERMISSIONS = 'SUCCESS_SAVE_ROLE_PERMISSIONS';
export const FAIL_SAVE_USER_ROLE = 'FAIL_SAVE_USER_ROLE';
export const SUCCESS_SAVE_USER_ROLE = 'SUCCESS_SAVE_USER_ROLE';
export const FAIL_DELETE_USER_ROLE = 'FAIL_DELETE_USER_ROLE';
export const SUCCESS_DELETE_USER_ROLE = 'SUCCESS_DELETE_USER_ROLE';
// NOTIFICATION
export const SUCCESS_FETCH_NOTIFICATION = 'SUCCESS_FETCH_NOTIFICATION';
export const FAIL_FETCH_NOTIFICATION = 'FAIL_FETCH_NOTIFICATION';
// TASK
export const SUCCESS_FETCH_TASK_MENU = 'SUCCESS_FETCH_TASK_MENU';
export const FAIL_FETCH_TASK_MENU = 'FAIL_FETCH_TASK_MENU';
export const SUCCESS_FETCH_TASK_TICKET = 'SUCCESS_FETCH_TASK_TICKET';
export const FAIL_FETCH_TASK_TICKET = 'FAIL_FETCH_TASK_TICKET';
// OBJECT PERMISSION
export const SUCCESS_FETCH_OBJECT_PERMISSION = 'SUCCESS_FETCH_OBJECT_PERMISSION';
export const FAIL_FETCH_OBJECT_PERMISSION = 'FAIL_FETCH_OBJECT_PERMISSION';
export const SUCCESS_SAVE_OBJECT_PERMISSION = 'SUCCESS_SAVE_OBJECT_PERMISSION';
export const FAIL_SAVE_OBJECT_PERMISSION = 'FAIL_SAVE_OBJECT_PERMISSION';
// DETAIL PRAQUALIFICATION
export const SUCCESS_SHOW_PRA_QUALIFICATION_DETAIL = 'SUCCESS_SHOW_PRA_QUALIFICATION_DETAIL';
export const FAIL_SHOW_PRA_QUALIFICATION_DETAIL = 'FAIL_SHOW_PRA_QUALIFICATION_DETAIL';
//FORGOT PASSWORD
export const SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';
export const FAIL_FORGOT_PASSWORD = 'FAIL_FORGOT_PASSWORD';
export const MODAL_SHOW_TRUE = 'MODAL_SHOW_TRUE';
export const MODAL_SHOW_FALSE = 'MODAL_SHOW_FALSE';
export const SUCCESS_AUTH_FETCH = 'SUCCESS_AUTH_FETCH';
export const FAIL_AUTH_FETCH = 'FAIL_AUTH_FETCH';

export const SUCCESS_SEND_MFA = 'SUCCESS_SEND_MFA';
export const FAIL_SEND_MFA = 'FAIL_SEND_MFA';
export const SUCCESS_VERIFY_MFA = 'SUCCESS_VERIFY_MFA';
export const FAIL_VERIFY_MFA = 'FAIL_VERIFY_MFA';

export const SUCCESS_RESET_PASSWORD = 'SUCCESS_RESET_PASSWORD';
export const FAIL_RESET_PASSWORD = 'FAIL_RESET_PASSWORD';
